import { ReactElement } from "react";
import classNames from "classnames";
import styles from "./Layout.module.css";

//#region [Props]
type LayoutProps = {
	children: React.ReactNode;
	className?: string;
};
//#endregion

//#region [Component]
const Layout = ({ children, className }: LayoutProps) => {
	return <main className={classNames(styles.main, className)}>{children}</main>;
};

export default Layout;
//#endregion